module.exports = __webpack_public_path__ + "img/marker-green.a3fe0246.svg";